export default function CourseDetails() {
  return (
    <section id="courses" className="py-24 bg-gray-950">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>
                Comprehensive Learning Experience
              </h2>
              <p className="text-xl text-gray-400 mb-8 leading-relaxed">
                Our courses are designed to take you from beginner to expert with a structured learning path that combines theory, practice, and real-world applications.
              </p>

              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-500/10 rounded-lg border border-teal-500/20">
                    <i className="ri-book-open-line text-xl text-teal-400"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Structured Curriculum</h3>
                    <p className="text-gray-400">Step-by-step learning modules designed by industry experts</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-500/10 rounded-lg border border-teal-500/20">
                    <i className="ri-code-box-line text-xl text-teal-400"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Live Coding Sessions</h3>
                    <p className="text-gray-400">Interactive sessions where you code alongside instructors</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-500/10 rounded-lg border border-teal-500/20">
                    <i className="ri-trophy-line text-xl text-teal-400"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">Capstone Projects</h3>
                    <p className="text-gray-400">Build portfolio-worthy projects to showcase your skills</p>
                  </div>
                </div>

                <div className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-teal-500/10 rounded-lg border border-teal-500/20">
                    <i className="ri-question-answer-line text-xl text-teal-400"></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-white mb-2">24/7 Support</h3>
                    <p className="text-gray-400">Get help whenever you need it from our support team</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="relative rounded-2xl overflow-hidden border border-gray-800 shadow-2xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/d911c52b3e3a6910197bccf4dc9ba11b.jpg"
                  alt="Course Learning"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-transparent to-transparent"></div>
              </div>

              <div className="absolute -bottom-6 -left-6 bg-gray-900 border border-gray-800 rounded-xl p-6 shadow-xl">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg">
                    <i className="ri-play-circle-line text-3xl text-gray-900"></i>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-white">100+</div>
                    <div className="text-sm text-gray-400">Video Lessons</div>
                  </div>
                </div>
              </div>

              <div className="absolute -top-6 -right-6 bg-gray-900 border border-gray-800 rounded-xl p-6 shadow-xl">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-teal-500 to-cyan-500 rounded-lg">
                    <i className="ri-file-text-line text-3xl text-gray-900"></i>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-white">50+</div>
                    <div className="text-sm text-gray-400">Lab Exercises</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}